import Pill from './pill';
export default Pill;